import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Chat, DetailedChat, MessageData } from "./types";
import { environment } from "@environments/environment";
import { EventSourcePolyfill } from "ng-event-source";

@Injectable({
  providedIn: "root",
})
export class ChatService {
  constructor(private http: HttpClient) {}

  private chatUrl = environment.chatBackendBaseURL + "/conversation/chat";

  getChat(
    subscription_id: string,
    conversation_id: string
  ): Observable<DetailedChat> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http.get<DetailedChat>(
      `${this.chatUrl}/${subscription_id}/conversation/${conversation_id}`,
      httpOptions
    );
  }

  getChats(subscription_id: string): Observable<DetailedChat[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http.get<DetailedChat[]>(
      `${this.chatUrl}/${subscription_id}`,
      httpOptions
    );
  }

  updateChat(
    subscription_id: string,
    conversation_id: string,
    message: string
  ): Observable<DetailedChat> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.put<DetailedChat>(
      `${this.chatUrl}/${subscription_id}`,
      { conversation_id, message },
      httpOptions
    );
  }

  addChat(subscription_id: string, message: string): Observable<Chat> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.post<Chat>(
      `${this.chatUrl}/${subscription_id}`,
      { message },
      httpOptions
    );
  }

  getChatStream(
    subscription_id: string,
    conversation_id: string,
    jwt: string
  ): Observable<MessageData> {
    const eventSource = new EventSourcePolyfill(
      `${this.chatUrl}/stream/${subscription_id}/conversation/${conversation_id}`,
      { headers: { Authorization: "Bearer " + jwt } }
    );

    return new Observable((observer) => {
      eventSource.onmessage = (event) => {
        const messageData: MessageData = JSON.parse(event.data);
        observer.next(messageData);
        if (messageData.status === "inserted") {
          eventSource.close();
        }
      };
    });
  }

  deleteChat(
    subscription_id: string,
    conversation_id: string
  ): Observable<number> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.delete<number>(
      `${this.chatUrl}/${subscription_id}/conversation/${conversation_id}`,
      httpOptions
    );
  }

  
  getFormJson(): Observable<any>{
    return this.http.get("/assets/data/form-generator.json");
  }
}
